import { Injectable } from '@angular/core';
import { BrowserNavigationService, DeferredNavigation } from './browser-navigation.service';


@Injectable()
export class WebBrowserNavigationService extends BrowserNavigationService {
  open(url: string, target: '_blank' | '_self' = '_blank'): void {
    const newTab = window.open(url, target);

    if (newTab) {
      newTab.focus();
    }
  }

  beginDeferredNavigation(): DeferredNavigation {
    const newTab = window.open('', '_blank');

    if (newTab) {
      newTab.focus();
    }

    return {
      navigate: (url: string) => {
        if (newTab && !newTab.closed) {
          newTab.location.replace(url);
          return;
        }

        this.open(url);
      },
      cancel: () => {
        if (newTab && !newTab.closed) {
          newTab.close();
        }
      }
    };
  }
}
